import { makeStyles, tokens } from '@fluentui/react-components';
import { px } from '@this/app-shared/dist/tools/styles.js';

export const useSharedStyles = makeStyles({
    container: {
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        gap: tokens.spacingHorizontalXS,
        alignSelf: 'flex-start',
        height: tokens.spacingHorizontalXL,
    },
    button: {
        position: 'relative',
        marginBlock: px(-10),
    },
});
